import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import extend from 'extend'

import StringTableService from '../../services/string-table'
import StoreService from '../../services/ephemeral-store'
import Auth from '../../actions/auth'
import LazyComponent from '../../components/lazy-component'
import FullScreenForm from '../../components/full-screen-form'

const defaultLocation = {
    state: {
        title: 'You are logged out',
        message: '',
        detail: ''
    }
}

class LoggedOutPage extends LazyComponent {

    static propTypes = {
        auth: PropTypes.object.isRequired,
        dispatch: PropTypes.func.isRequired,
        location: PropTypes.object, // injected by react-router
    }

    constructor(props) {
        super(props)
        this.login = this.login.bind(this)
        this.loadModules(['react-bootstrap'])
    }

    componentWillMount() {
        const { auth, dispatch } = this.props
        const deepLinkKey = StringTableService.getString(StringTableService.keys.deepLinkKey)
        const store = new StoreService()
        store.remove(deepLinkKey, '')
        dispatch(auth.logout())
    }

    login() {
        const loginRoute = StringTableService.getString(StringTableService.keys.loginRoute)
        this.props.dispatch(push(loginRoute))
    }

    lazyRender() {

        const {
            Modal,
            Button
        } = this.modules['react-bootstrap']

        const state = extend({}, defaultLocation.state, this.props.location.state)
        const { title, message, detail } = state

        return (
            <FullScreenForm>
                <Modal show>
                    <Modal.Header>
                        <Modal.Title>{title}</Modal.Title>
                    </Modal.Header>
                    {message &&
                        <Modal.Body>
                            <h3>{message}</h3>
                            <div>{detail}</div>
                        </Modal.Body>
                    }
                    <Modal.Footer>
                        <Button
                            bsStyle="primary"
                            onClick={this.login}
                        >
                            Log in
                        </Button>
                    </Modal.Footer>
                </Modal>
            </FullScreenForm>
        )

    }

}

const mapStateToProps = () => {
    return {
        auth: new Auth()
    }
}

export default connect(mapStateToProps)(LoggedOutPage)


// WEBPACK FOOTER //
// src/pages/logged-out-page/index.js